import { Chart, ChartOption } from './Chart';
import { Box } from '@mui/material';

type MonthData = {
  nome: string;
  valor_secundario: number;
};

type DataProps = {
  backgroundStyle?: boolean;
  lineColor?: string;
  pointColor?: string;
  title?: string;
  data: {
    valor_secundario: number;
    ano: number;
    meses: MonthData[];
  }[];
  name?: string
};

const LineChart: React.FC<DataProps> = ({ backgroundStyle = true, lineColor, pointColor, title, data, name = '' }) => {
  const months = data[0]?.meses.map(m => m.nome) || [];
  const values = data[0]?.meses.map(m => m.valor_secundario) || [];

  const option = {
    title: {
      text: title || `Histórico do percentual de inadimplência do aluno: ${name}`,
      textStyle: {
        fontSize: '14px',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },
      formatter: function (params: any) {
        const value = params[0]?.data;
        return `${params[0]?.name}: ${value}%`;
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: months,
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value}%', 
          margin: 30,
        },
      },
    ],
    series: [
      {
        name: 'Ano x Score geral',
        type: 'line',
        smooth: true,
        label: {
          show: true,
          position: 'top',
          color: pointColor || '#000',
          formatter: '{c}%',
        },
        symbol: 'circle',
        symbolSize: 14,
        areaStyle: {
          color: backgroundStyle ? {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0, color: 'rgba(252, 159, 159, 0.6)'
              },
              {
                offset: 1, color: '#FFF'
              }
            ]
          } : 'transparent',
        },
        lineStyle: {
          color: lineColor || '#E04A4C',
          width: 4,
        },
        itemStyle: {
          borderWidth: 1,
          color: lineColor || '#E04A4C',
        },
        emphasis: {
          focus: 'series',
        },
        data: values,
      },
    ],
  } as ChartOption;

  return (
    <Box height={'400px'} p={2}>
      <Chart option={option} />
    </Box>
  );
};

export default LineChart;
